import "./Terms.css";

const Terms = () => {
  return (
    <section className="legal-section">
      <h1>Terms & Conditions</h1>
      <div className="legal-content">
        <p className="last-updated">Last updated: January 2026</p>

        <div className="legal-item">
          <h2>Website Use</h2>
          <p>
            You agree to use this website lawfully and not submit false,
            misleading, or harmful information.
          </p>
        </div>

        <div className="legal-item">
          <h2>Travel Information Disclaimer</h2>
          <p>
            All travel information is for general guidance only and may change
            without notice.
          </p>
        </div>

        <div className="legal-item">
          <h2>No Booking Guarantee</h2>
          <p>
            Submitting an inquiry does not constitute a confirmed booking or
            contractual agreement.
          </p>
        </div>

        <div className="legal-item">
          <h2>Intellectual Property</h2>
          <p>
            All content on this website is the property of Mystique Realm and
            may not be used without permission.
          </p>
        </div>

        <div className="legal-item">
          <h2>Limitation of Liability</h2>
          <p>
            We are not liable for any damages resulting from the use of this
            website or reliance on its content.
          </p>
        </div>

        <div className="legal-item">
          <h2>Governing Law</h2>
          <p>
            These Terms & Conditions are governed by the laws of the Kingdom of
            Bhutan.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Terms;
